<template>
  <div>
    <div class="login">
      <div class="login_header">
        <div class="layout_pannel">
          <div class="logo" @click="$router.push('/home')">
            <img src="../../assets/img/index-logo.jpg" alt="" />
          </div>
        </div>
      </div>
      <div class="login_main">
        <div class="main_bg layout_pannel">
          <h1 :class="current">供应商登录</h1>
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="90px" class="demo-ruleForm">
            <el-form-item label="用户名" prop="username">
              <el-input prefix-icon="el-icon-user" placeholder="用户名" v-model.trim="ruleForm.username" @input="onNameInput"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input type="password" placeholder="密码" prefix-icon="el-icon-lock" v-model.trim="ruleForm.password"
                show-password @keyup.enter.native="login"></el-input>
            </el-form-item>
            <el-row style="display: flex; align-items: center;">
              <el-col :span="16">
                <el-form-item label="授权码" prop="accesscode" style="margin: 0">
                  <el-input placeholder="授权码" prefix-icon="el-icon-view" v-model="ruleForm.accesscode"
                    @keyup.enter.native="login"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-checkbox v-model="rememberCode" label="记住" size="large" />
              </el-col>
            </el-row>
            <el-form-item>
              <el-button type="primary" @click="login" @keyup.enter.native="login">登录</el-button>
            </el-form-item>

          </el-form>
        </div>
      </div>
      <div class="login_footer">
        <div class="layout_pannel"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { postAction } from "../../api/index";
export default {
  data() {
    var checkUsername = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入用户名"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };
    return {
      current: 0,
      account: "",
      password: "",
      rememberCode: false,
      savedAccounts: [],
      ruleForm: {
        username: "",
        password: "",
        accesscode: "",
      },
      rules: {
        username: [{ validator: checkUsername, trigger: "blur" }],
        password: [{ validator: validatePass, trigger: "blur" }],
      },
    };
  },
  created() {
    // 隐藏头部和尾部
    this.$store.state.showH = false;
    this.$store.state.showF = false;
    this.loadSavedRemember();
  },
  methods: {

    // 用户名输入时触发
    onNameInput() {
      if(this.ruleForm.username === "") return;
      const matched = this.savedAccounts.find(acc => acc.username === this.ruleForm.username)
      if (matched) {
        this.ruleForm.accesscode = matched.accesscode;
        this.rememberCode = true;
      }else{
        this.ruleForm.accesscode = "";
        this.rememberCode = false;
      }
    },
    // 加载已保存的所有账号（用户名）
    loadSavedRemember() {
      const accountsStr = localStorage.getItem('savedLoginAccountsWH');
      this.savedAccounts = JSON.parse(accountsStr && accountsStr != 'null' && accountsStr != 'undefined' ? accountsStr : '[]')
      // this.onNameInput();
    },
    saveRemember(realCode){
      if(this.ruleForm.username === "") return;
      this.savedAccounts = this.savedAccounts.filter(acc => acc.username !== this.ruleForm.username)
      if(this.ruleForm.accesscode != "" && this.ruleForm.accesscode == realCode && this.rememberCode){
        this.savedAccounts.push({
          username: this.ruleForm.username,
          accesscode: this.ruleForm.accesscode
        })
      }
      // 限制最多保存 5 个账号（可选）
      if (this.savedAccounts.length > 5) {
        this.savedAccounts.shift() // 移除最早的一个
      }
      localStorage.setItem('savedLoginAccountsWH', JSON.stringify(this.savedAccounts))
      // this.loadSavedRemember() // 更新下拉列表
    },


    // 登录
    login() {
      let that = this;
      that.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          let formData ={}
          formData.username = that.ruleForm.username
          formData.password = that.$md5(that.ruleForm.password);
          formData.accesscode = that.ruleForm.accesscode
          postAction("/users/providerLogin", formData).then((res) => {
            if (res.data.success) {
              that.$store.dispatch('setUserInfo', res.data)
              // that.$store.state.userInfo = res.data.result.user;
              // window.sessionStorage.setItem(
              //   "userInfo",
              //   JSON.stringify(res.data.result.user)
              // );
              // that.$store.state.userLoginTime = Date.parse(new Date());
              // window.sessionStorage.setItem(
              //   "userLoginTime",
              //   Date.parse(new Date())
              // );
              that.$store.state.shopWHCart = res.data.result.cartItem;
              try {
                window.sessionStorage.setItem(
                  "shopWHCart",
                  JSON.stringify(res.data.result.cartItem)
                );
              } catch (e) {
                console.log('sessionStorage-shopWHCart存储失败',res.data.result.cartItem)
              }
              
              that.saveRemember(res.data.result.user.accessCode);
              this.$message({
                message: "登录成功!",
                type: "success",
              });
              // 跳到指定页面
              if (this.$route.query.redirect) {
                var ts = JSON.parse(window.sessionStorage.getItem("ts"));
                this.$router.push({
                  path: this.$route.query.redirect,
                  params: ts,
                  name: this.$route.query.name,
                });
                // window.sessionStorage.removeItem("ts");
              } else {
                  this.$router.push("/provider/accountInfo");
              }
            } else {
              this.$message({
                message: "登录遇到问题，" + res.data.message,
                type: "error",
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    goRegister() {
      this.$router.push("/register");
    },
  },
};
</script>

<style lang="scss" scoped>
$mainColor: #5cadff;

.el-input__inner {
  height: 100px;
}
.el-button {
  width: 80%;
}
.el-form-item {
  margin-top: 30px;
  .el-input {
    width: 80%;
    // height: 50px;
    background-color: #fff;
    box-sizing: border-box;
    outline: none;
  }
}
.layout_pannel {
  margin: 0 auto;
  width: 1130px;
}
.login {
  .login_header {
    height: 98px;
    background-color: #fff;
    .logo {
      margin-top: 24px;
      margin-bottom: 24px;
      float: left;
      width: 200px;
      height: 50px;
      cursor: pointer;
    }
  }
  .login_main {
    height: 588px;
    background: url("../../assets/img/banner/a1.jpg") no-repeat center center;
    .main_bg {
      position: absolute;
      top: 20%;
      left: 60%;
      width: 30%;
      height: 400px;
      background-color: #fff;
      h1 {
        margin-top: 29px;
        font-size: 22px;
        cursor: pointer;
        font-weight: normal;
        display: inline-block;
        width: calc(93% - 2px);
        height: 29px;
        line-height: 29px;
        text-align: center;
        vertical-align: middle;
        &.active {
          color: $mainColor;
        }
        &:hover {
          color: $mainColor;
        }
      }
      form {
        margin-top: 30px;
        .login_way {
          margin-top: 30px;
          margin-bottom: 24px;
        }
      }
    }
  }
  .login_footer {
    height: 177px;
    background-color: #fff;
    font-size: 14px;
    padding: 85px;
    box-sizing: border-box;
    text-align: center;
    .option {
      margin: 10px 0;
      span {
        margin: 0 10px;
        &:last-child {
          display: none;
        }
      }
    }
    .copyright {
      a {
        img {
          vertical-align: baseline;
          display: inline-block;
          height: 20px;
          width: auto;
        }
      }
    }
  }
}
</style>
